import { ReactComponent as YoutubeSVG } from '../Assets/youtube.svg'
import { ReactComponent as TwitterSVG } from '../Assets/twitter.svg'
import { ReactComponent as GithubSVG } from '../Assets/github.svg'


function Footer() {
    return <>
        <footer>
            <div className="copyright">
                <hr />
                Copyright © 2021 Fireship LLC
                <br />
                <hr />

                {/* TODO: Spacing b/w icons are not correct */}
                <div style={{ padding: "20px 0", fontSize: "1.5em" }}>
                    <SocialLink Icon={GithubSVG} elemClass="github" link="https://github.com/pseudo-usama" />
                    <SocialLink Icon={TwitterSVG} elemClass="twitter" link="https://twitter.com/UsamaIftikharB1" />
                    <SocialLink Icon={YoutubeSVG} elemClass="youtube" link="https://www.youtube.com/channel/UCBLJy-IzwLY3gkrNQI8yABA" />
                </div>
            </div>
        </footer>
    </>
}


function SocialLink({ Icon, elemClass, link }) {
    return <>
        <a href={link} target="_blank" rel="noreferrer">
            <i className={elemClass}>
                <Icon />
            </i>
        </a>
    </>
}


export default Footer
